<template>
  <div class="SafeSettings">
    <el-main>
      <UserCenterTop />
      <el-row class="nofull event_content">
        <UserMenu :myMenuActiveId="myMenuActiveId" />
        <el-main>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>学者中心</el-breadcrumb-item>
            <el-breadcrumb-item>个人信息</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="row_header">
            <div class="row_title fl">个人信息</div>
            <div class="row_inside fr"></div>
          </div>
          <MyInfoMenu :myInfoMenuActiveIndex="myInfoMenuActiveIndex" />
          <div class="thSubMainBox">
            <span>账号密码</span><br />
            <span style="color: #8c939d; font-size: 13px"
              >当前密码强度：强</span
            >
            <el-link
              type="primary"
              class="fr"
              @click="passwordModifyDialog = true"
              >修改</el-link
            >
            <el-divider></el-divider>
            <span>绑定邮箱</span><br />
            <span style="color: #8c939d; font-size: 13px"
              >已绑定邮箱：{{ myEmail }}</span
            >
            <el-link type="primary" class="fr" @click="openEmailModifyDialog"
              >修改</el-link
            >
          </div>
          <el-dialog
            title="修改密码"
            :visible.sync="passwordModifyDialog"
            width="30%"
            :destroy-on-close="true"
            :close-on-click-modal="false"
            :before-close="handleClose"
          >
            <span>
              <el-form
                :model="formPassword"
                ref="formPassword"
                :rules="passwordRules"
                labelWidth="80px"
                label-position="left"
              >
                <el-form-item label="旧密码" prop="oldPassword">
                  <el-input
                    type="password"
                    v-model="formPassword.oldPassword"
                    placeholder="请输入旧密码"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="visible" label="新密码" prop="newPassword">
                  <el-input
                    type="password"
                    v-model="formPassword.newPassword"
                    placeholder="请输入新密码"
                  >
                    <i
                      slot="suffix"
                      title="显示密码"
                      @click="changePass('show')"
                      style="cursor: pointer"
                      class="el-input__icon el-icon-aim"
                    ></i>
                  </el-input>
                </el-form-item>
                <el-form-item v-else label="新密码" prop="newPassword">
                  <el-input
                    type="text"
                    v-model="formPassword.newPassword"
                    placeholder="请输入新密码"
                  >
                    <i
                      slot="suffix"
                      title="隐藏密码"
                      @click="changePass('hide')"
                      style="cursor: pointer"
                      class="el-input__icon el-icon-s-opportunity"
                    ></i>
                  </el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="conformNewPassword">
                  <el-input
                    type="password"
                    v-model="formPassword.conformNewPassword"
                    placeholder="请再次输入新密码"
                  >
                  </el-input>
                </el-form-item>
              </el-form>
            </span>
            <el-alert
              :style="{ display: passwordModifyMessageVisible }"
              :title="passwordModifyMessage"
              type="error"
              @close="passwordModifyMessageClose"
            >
            </el-alert>
            <span slot="footer" class="dialog-footer">
              <el-button @click="cancelPasswordModify">取 消</el-button>
              <el-button
                type="primary"
                @click="handlePasswordModify('formPassword')"
                >确 定</el-button
              >
            </span>
          </el-dialog>
          <!-- 修改绑定邮箱 -->
          <el-dialog
            class="new_email_dialog"
            title="修改绑定邮箱"
            :visible.sync="emailModifyDialog"
            width="30%"
            :destroy-on-close="true"
            :close-on-click-modal="false"
            :before-close="handleEmailModifyClose"
          >
            <span>
              <el-form
                :model="formNewEmail"
                ref="formNewEmail"
                :rules="emailRules"
                label-position="left"
              >
                <el-form-item class="loginFormItem" prop="new_email">
                  <el-input
                    placeholder="请输入新邮箱"
                    v-model="formNewEmail.new_email"
                    style="width: 320px"
                  >
                    <template slot="prepend"
                      >新<span style="margin-left: 0.5em" />邮<span
                        style="margin-left: 0.5em" />箱<i
                        class="el-icon-message"
                    /></template>
                  </el-input>
                </el-form-item>
                <div class="loginFormItem inlineFlex">
                  <el-input
                    placeholder="输入验证码"
                    v-model="formNewEmail.captcha_code"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                    maxlength="4"
                  >
                    <template slot="prepend"
                      >验<span style="margin-left: 0.5em" />证<span
                        style="margin-left: 0.5em" />码<i class="el-icon-lock"
                    /></template>
                  </el-input>
                  <div
                    class="captcha_code"
                    v-if="formNewEmail.showCaptchaBtn === 0"
                  >
                    <img
                      :src="formNewEmail.captcha_url"
                      ref="code"
                      @click="changeCode"
                    />
                    <span style="font-size: 12px">看不清？点图刷新</span>
                  </div>
                  <el-button
                    v-if="formNewEmail.showCaptchaBtn === 1"
                    style="margin-left: 10px; padding: 12px"
                    @click="toGetCaptchaCode"
                    >获取验证码</el-button
                  >
                </div>
                <div class="loginFormItem inlineFlex" prop="captcha_code">
                  <el-input
                    placeholder="输入认证码"
                    v-model="formNewEmail.verify_code"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                    maxlength="4"
                  >
                    <template slot="prepend"
                      >认<span style="margin-left: 0.5em" />证<span
                        style="margin-left: 0.5em" />码<i class="el-icon-lock"
                    /></template>
                  </el-input>
                  <el-button
                    style="margin-left: 10px; padding: 12px"
                    :disabled="sendMsgDisabled"
                    @click="sendRegCapthaCode()"
                  >
                    <span v-if="!sendMsgDisabled">获取认证码</span>
                    <span v-if="sendMsgDisabled">{{
                      codeTime + '秒后获取'
                    }}</span>
                  </el-button>
                </div>
              </el-form>
            </span>
            <el-alert
              :style="{ display: newEmailMessageVisible }"
              :title="newEmailMessage"
              type="error"
              @close="emailModifyMessageClose"
            >
            </el-alert>
            <span slot="footer" class="dialog-footer">
              <el-button @click="cancelEmailModify">取 消</el-button>
              <el-button
                type="primary"
                @click="handleEmailModify('formNewEmail')"
                >确 定</el-button
              >
            </span>
          </el-dialog>
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import UserMenu from '@/components/UserMenu';
import UserCenterTop from '@/components/UserCenterTop';
import MyInfoMenu from '@/components/MyInfoMenu';
import { passwordModify } from '@/apis/passwordModify.js';
import { emailModifyCode } from '@/apis/emailModify.js';
import { getCaptcha } from '@/apis/captcha';
import { emailModify } from '@/apis/emailModify';
export default {
  name: 'SafeSettings',
  components: {
    UserMenu,
    UserCenterTop,
    MyInfoMenu,
  },

  mounted() {
    this.$emit('activeIndex', '3');
    this.$emit('pageClass', 'userCenter');
  },

  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.formPassword.newPassword !== '') {
          this.$refs.formPassword.validateField('conformNewPassword');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.formPassword.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
        ],
        newPassword: [
          {
            validator: validatePass,
            required: true,
            message: '请输入新密码',
            trigger: 'blur',
          },
          { min: 6, message: '密码至少 6 个字符', trigger: 'blur' },
          { max: 20, message: '密码最多 20 个字符', trigger: 'blur' },
        ],
        conformNewPassword: [
          { validator: validatePass2, required: true, trigger: 'blur' },
        ],
      },

      emailRules: {
        new_email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change'],
          },
        ],
        captcha_code: [
          {
            required: true,
            message: '请输入邮箱中收到的验证码',
            trigger: 'blur',
          },
          { min: 4, message: '输入4位验证码', trigger: 'blur' },
          { max: 4, message: '输入4位验证码', trigger: 'blur' },
        ],
      },

      userName: '个人信息',
      myMenuActiveId: '2',
      myInfoMenuActiveIndex: '2',

      // myEmail: 'zhangmoumou@gmail.com',
      passwordModifyDialog: false,
      emailModifyDialog: false,
      passwordModifyMessage: '',
      passwordModifySuccessMessage: '',
      newEmailMessage: '',
      emailModifySuccessMessage: '',
      newEmailMessageVisible: 'none',
      codeTime: 59, // 发送验证码倒计时

      formPassword: {
        oldPassword: '',
        newPassword: '',
        conformNewPassword: '',
      },
      formNewEmail: {
        new_email: '',
        captcha_code: '',
        captcha_url: '',
        verify_code: '',
        showCaptchaBtn: 1,
      },
      sendMsgDisabled: false, // 是否显示获取验证码按钮
      visible: true,
      passwordModifyMessageVisible: 'none',
      captcha_id: '',
    };
  },
  methods: {
    changePass(value) {
      this.visible = !(value === 'show');
    }, //判断渲染，true:暗文显示，false:明文显示

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
          this.formPassword.oldPassword = '';
          this.formPassword.newPassword = '';
          this.formPassword.conformNewPassword = '';
        })
        .catch(() => {});
    },

    cancelPasswordModify() {
      this.passwordModifyDialog = false;
      this.formPassword.oldPassword = '';
      this.formPassword.newPassword = '';
      this.formPassword.conformNewPassword = '';
    },

    passwordModifyMessageClose() {
      this.passwordModifyMessageVisible = 'none';
    },

    handlePasswordModify(fn) {
      this.$refs[fn].validate((valid) => {
        if (valid) {
          passwordModify({
            old_login_pwd: this.formPassword.oldPassword,
            new_login_pwd: this.formPassword.newPassword,
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.success === true) {
                  this.passwordModifySuccessMessage = res.data.message;
                  this.cancelPasswordModify();
                  this.passwordModifySuccess();
                } else {
                  this.passwordModifyMessage = res.data.message;
                  this.passwordModifyMessageVisible = 'block';
                  console.log(res.data);
                }
              } else {
                this.$message.error('未请求成功');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    passwordModifySuccess() {
      this.$confirm(
        this.passwordModifySuccessMessage + '，请重新登录',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success',
        },
      )
        .then(() => {
          localStorage.removeItem('eleToken');
          this.$store.commit('AddIsLogin', 0);
          this.$router.push('/');
          this.$store.commit('blOpenLoginBox', true);
        })
        .catch(() => {
          localStorage.removeItem('eleToken');
          this.$store.commit('AddIsLogin', 0);
          this.$router.push('/');
        });
    },
    // 修改邮箱-----
    openEmailModifyDialog() {
      this.emailModifyDialog = true;
      this.toGetCaptchaCode();
    },
    // 注册认证码获取
    sendRegCapthaCode() {
      this.$refs['formNewEmail'].validate((valid) => {
        if (valid) {
          emailModifyCode({
            new_email: this.formNewEmail.new_email,
            captcha_id: this.captcha_id,
            captcha_code: this.formNewEmail.captcha_code,
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.success === true) {
                  console.log(res.data.data);
                  this.newEmailMessage = '认证码已发至您的邮箱';
                  this.newEmailMessageVisible = 'block';
                  this.sendMsgDisabled = true;
                  let codeInterval = window.setInterval(() => {
                    this.codeTime--;
                    if (this.codeTime < 0) {
                      window.clearInterval(codeInterval);
                      this.codeTime = 59;
                      this.sendMsgDisabled = false;
                    }
                  }, 1000);
                } else {
                  this.newEmailMessage = res.data.message;
                  this.newEmailMessageVisible = 'block';
                }
              } else {
                this.$message.error('未能发送验证码');
                console.log('错误');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    // 生成验证码随机字符
    randomCaptchaKey() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      this.captcha_id =
        S4() +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        S4() +
        S4();
    },
    // 得到验证码图片
    changeCode() {
      this.randomCaptchaKey();
      getCaptcha({ captcha_id: this.captcha_id })
        .then((res) => {
          if (res.status === 200) {
            let rr = window.URL.createObjectURL(res.data);
            this.formNewEmail.captcha_url = rr;
          } else {
            this.$message.error('未请求成功');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toGetCaptchaCode() {
      this.changeCode();
      this.formNewEmail.showCaptchaBtn = 0;
    },
    // 关闭修改邮箱弹窗
    cancelEmailModify() {
      this.emailModifyDialog = false;
      this.formNewEmail.new_email = '';
      this.formNewEmail.captcha_code = '';
      this.newEmailMessageVisible = 'none';
      this.formNewEmail.showCaptchaBtn = 1;
    },
    handleEmailModifyClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done();
          this.cancelEmailModify();
        })
        .catch(() => {});
    },
    // 邮箱修改信息显示
    emailModifyMessageClose() {
      this.newEmailMessageVisible = 'none';
    },
    // 提交修改邮箱
    handleEmailModify(fn) {
      this.$refs[fn].validate((valid) => {
        if (valid) {
          emailModify({
            verify_code: this.formNewEmail.verify_code,
            new_email: this.formNewEmail.new_email,
          })
            .then((res) => {
              if (res.status === 200) {
                if (res.data.success === true) {
                  this.emailModifySuccessMessage = res.data.message;
                  this.cancelEmailModify();
                  this.emailModifySuccess();
                } else {
                  this.newEmailMessage = res.data.message;
                  this.newEmailMessageVisible = 'block';
                  console.log(res.data);
                }
              } else {
                this.$message.error('未请求成功');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    emailModifySuccess() {
      this.$confirm(this.emailModifySuccessMessage + '，请重新登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success',
      })
        .then(() => {
          localStorage.removeItem('eleToken');
          this.$store.commit('AddIsLogin', 0);
          this.$router.push('/');
          this.$store.commit('blOpenLoginBox', true);
        })
        .catch(() => {
          localStorage.removeItem('eleToken');
          this.$store.commit('AddIsLogin', 0);
          this.$router.push('/');
        });
    },
  },
  computed: {
    myEmail: {
      get() {
        return this.$store.state.toGetCurrentUser.currentUserInfo.email;
      },
    },
  },
};
</script>

<style scoped></style>
